import React, { useState, useEffect } from "react";
import { data, useLocation, useNavigate, useParams } from "react-router-dom";

import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";

import moment from "moment";
import { enqueueSnackbar } from "notistack";
import CustomDrawer from "../../components/customComponents/drawer/CustomDrawer";
import CustomConfirmation from "../../components/customComponents/confirmation/CustomConfirmation";
import CustomMUITable from "../../components/customComponents/table/CustomMuiTable";
import FolderOpenIcon from "@mui/icons-material/FolderOpen"; // Open Cases

import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import {
  delete_Case_api,
  get_advisor_list_with_filters,
  get_cases_api,
  get_cases_Detail_api,
} from "../../DAL/adminAuth/auth";
import { show_proper_words } from "../../utils/constant";
import { makeStyles } from "@mui/styles";
import FilterDrawerCases from "../cases/FilterCase";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CasesFilterAttorney from "../cases/CasesFilterAttorney";

const AttorneyCaseDetail = () => {
  const useStyles = makeStyles(() => ({
    loading: {
      marginLeft: "50%",
      marginTop: "20%",
    },
  }));

  const INITIAL_VALUES = {
    selectedRow: null,
    loading: true,
    confirmDeleteOpenMember: false,
    drawerOpen: false,
    selectedCategory: null,
    members: [],
  };

  const [memberState, setMemberState] = useState(INITIAL_VALUES);
  const [selectedAdvisor, setSelectedAdvisor] = useState(null); // Changed to null for Autocomplete

  const [caseSStatusDATA, setCaseStatusData] = useState("");
  const [dashboardData, setDashboardData] = useState({});
  const location = useLocation();
  console.log(location, "locationlocationlocation");
  const stateData = location?.state?.data;
  console.log(stateData, "stateDatastateDatastateData");

  const classes = useStyles();

  const new_valyues = {
    deleteRecordingId: null,
    deleteDialogOpen: false,
    drawerOpen: false,
    selectedCategory: null,
    change_advisor_status_drawer: false,
    select_change_drawer_advisor: null,
    change_case_status_drawer: false,
    select_change_drawer_case: null,
    image: "",
  };

  const handleopenFilterDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      drawerOpen: true,
      selectedCategory: null,
    }));
  };

  const handleChangeCaseStatusOpen = (row) => {
    console.log("caslcxkasnc");
    setCaseStatusData(row);
    setRecordingListState((old) => ({
      ...old,
      change_case_status_drawer: true,
      select_change_drawer_case: null,
    }));
  };

  const handleopenChangeAdvisor = (row) => {
    console.log("akjsgdkjagd");
    setCaseStatusData(row);
    setRecordingListState((old) => ({
      ...old,
      change_advisor_status_drawer: true,
      select_change_drawer_advisor: null,
    }));
  };
  const handleCloseAdvisorDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      change_advisor_status_drawer: false,
    }));
  };

  const handleCloseDrawer = () => {
    setRecordingListState((old) => ({ ...old, drawerOpen: false }));
  };

  const [recordingListState, setRecordingListState] = useState(new_valyues);

  const [membersList, setMembersList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");
  const [sourceName, setSourcename] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const { advisor_id } = useParams();
  console.log(advisor_id, "idididid");
  const [caseType, setCaseType] = useState(null);

  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [caseStatus, setCaseStatus] = useState(null);
  const [states, setStates] = useState(""); // single state value

  const [filter, setFilter] = useState("");
  const navigate = useNavigate();
  const [sectorFilter, setSectorFilter] = useState(null);
  const [typeFilter, setTypeFilter] = useState(null);

  const [sourceFilter, setSourceFilter] = useState("");
  const [caseData, setCaseData] = useState([]);

  const [appliedFilters, setAppliedFilters] = useState({
    source: null,
    sector: null,
    type: null,
  });
  const [selectedSourceId, setSelectedSourceId] = useState(null);
  const [tempFilters, setTempFilters] = useState({
    caseType: null,
    occurrencePeriod: null,
    startDate: null,
    endDate: null,
    state: null,
    status: "",
    searchText: "",
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOccurancePeriod, setselectedOccurancePeriodId] =
    useState(null);
  const [userList, setUserList] = useState([]);

  const handleChangeRowsPerPage = (event) => {
    setIsLoading(true);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const get_user_list = async (
    case_type,
    // occurance,
    status,
    stateSend,
    start_date,
    end_date
  ) => {
    setIsLoading(true);

    console.log(start_date, end_date, "filters....");

    const caseParam = case_type !== undefined ? case_type : caseType || "";
    const statusparam = status !== undefined ? status : caseStatus || "";
    // const occurancePeriodParam =
    //   occurance !== undefined ? occurance : selectedOccurancePeriod || "";

    const TypeParam = stateSend !== undefined ? stateSend : states || "";
    const startDateParam = start_date
      ? moment(start_date).format("YYYY-MM-DD")
      : ""
      ? moment(startDate).format("YYYY-MM-DD")
      : "";

    const endDateParam = end_date
      ? moment(end_date).format("YYYY-MM-DD")
      : ""
      ? moment(endDate).format("YYYY-MM-DD")
      : "";
    console.log(
      caseParam,
      TypeParam,
      searchText,
      statusparam,
      startDateParam,
      endDateParam,
      "filters...."
    );

    const result = await get_cases_Detail_api(
      caseParam,
      TypeParam,
      searchText,
      statusparam,
      startDateParam,
      endDateParam,
      page,
      rowsPerPage,
      advisor_id
    );
    console.log(result, "resultresultresultresult");
    if (result.code === 200) {
      let data = result.case.map((item) => {
        let created_At = "N/A";
        let case_type = "N/A";
        let occurrencePeriod = "N/A";
        let status = "N/A";
        let state = "N/A";
        let advisor = "N/A";
        let caseDetails = "N/A";
        console.log(item, "itemitemitemitemitem");

        if (item.createdAt) {
          created_At = moment(item.createdAt).format("DD-MM-YYYY");
        }
        if (item.advisor_id?.name) {
          advisor = item.advisor_id?.name;
        }
        if (item.case_type) {
          case_type = item?.case_type;
        }

        if (item.occurrencePeriod) {
          occurrencePeriod = item?.occurrencePeriod;
        }
        if (item.status) {
          status = item?.status;
        }
        if (item.state) {
          state = item?.state;
        }
        if (item.caseDetails) {
          caseDetails = item?.caseDetails;
        }

        return {
          ...item,
          created_At,
          case_type,
          occurrencePeriod,
          status,
          state,
          caseDetails,
          advisor,
        };
      });
      setUserList(data);
      setTotalCount(result.total_count);
      setTotalPages(result.total_pages);
      setDashboardData(result);

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  console.log(dashboardData, "asdjvasjvdjasv");
  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "Case Type", key: "case_type" },
    { label: "Attorney", key: "advisor" },
    { label: "State", key: "state" },
    { label: "Occurrence Period", key: "occurrencePeriod" },
    { label: "Case Details", key: "caseDetails" },
    { label: "Added At", key: "createdAt" },
  ];

  function download_csv_file(headers, data) {
    const headerRow = headers.map((column) => column.label);
    const csvRows = [headerRow];

    data.forEach((row) => {
      const dataRow = headers.map((column) => row[column.key] || "");
      csvRows.push(dataRow);
    });

    const csvContent = csvRows.map((row) => row.join(",")).join("\n");

    const hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
    hiddenElement.target = "_blank";
    hiddenElement.download = "transactions.csv";
    hiddenElement.click();
  }

  const handleExportCsv = async () => {
    setIsLoading(true);
    try {
      const caseParam = caseType || "";
      const statusparam = caseStatus || "";
      const TypeParam = states || "";
      const startDateParam = startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : "";
      const endDateParam = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

      const result = await get_cases_Detail_api(
        caseParam,
        TypeParam,
        searchText,
        statusparam,
        startDateParam,
        endDateParam,
        0,
        600,
        advisor_id
      );

      if (result.code === 200 && result.case?.length) {
        console.log(result.case[0].user_id, "USER ID FIELDS CHECK");

        console.log(result, "suacuisacresultresultresult");
        const exportData = result.case.map((item) => ({
          ...item,
          case_type: item.case_type || "N/A",
          attorneys: item?.attorneys || "N/A",
          state: item?.state || "N/A",
          advisor: item?.advisor_id?.name || "N/A",
          occurrencePeriod: show_proper_words(item?.occurrencePeriod || "N/A"),
          caseDetails: item?.caseDetails || "N/A",
          createdAt: item?.createdAt
            ? moment(item.createdAt).format("DD-MM-YYYY")
            : "N/A",
          name: item?.user_id?.name || "N/A",
          email: item?.user_id?.email || "N/A",
          phone: item?.user_id?.phone || "N/A",
        }));

        download_csv_file(headers, exportData);
      } else {
        enqueueSnackbar("No data found to export", { variant: "info" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong while exporting", {
        variant: "error",
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(0);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
    get_user_list();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(0);
    } else {
      setPageCount(newPage + 1);
    }
    get_user_list();
  };

  const TABLE_HEAD = [
    // {
    //   id: "action",
    //   label: "Action",
    //   type: "action",
    //   MENU_OPTIONS: "MENU_OPTIONS",
    // },
    { id: "number", label: "#", type: "number" },
    { id: "state", label: "State" },
    { id: "advisor", label: "Attorney" },
    // { id: "case_type", label: "Case Type" },
    {
      id: "case_type",
      label: "Case Type",
      renderData: (row) => {
        return <span>{show_proper_words(row?.case_type)}</span>;
      },
    },
    {
      id: "occurrencePeriod",
      label: "Occurrence Period",
      renderData: (row) => {
        return <span>{show_proper_words(row?.occurrencePeriod)}</span>;
      },
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => {
        const status = row?.status;
        let backgroundColor = "";
        let textColor = "white";

        if (status === "failed") {
          backgroundColor = "#f44336";
        } else if (status === "pending") {
          backgroundColor = "#FF9800";
        } else if (status === "recovered") {
          backgroundColor = "#4CAF50";
          textColor = "#fff";
        } else if (status === "assigned") {
          backgroundColor = "#6e4b45";
          textColor = "#fff";
        }
        const getStatusLabel = (status) => {
          if (status === "pending") return "Pending";
          if (status === "recovered") return "Recovered";
          if (status === "failed") return "Failed";
          if (status === "assigned") return "Assigned";
          return status;
        };

        return (
          <span
            style={{
              backgroundColor,
              color: textColor,
              padding: "4px 8px",
              borderRadius: "12px",
              fontSize: "12px",
              display: "inline-block",
              minWidth: "60px",
              textAlign: "center",
            }}
          >
            {getStatusLabel(status)}
          </span>
        );
      },
    },
  ];
  function capitalizeWords(string) {
    return string
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  function fullWord(str) {
    if (!str) return "";
    const replacements = {
      clients: "Client",
      industry_suppliers: "Industry Supplier",
    };

    const lowerStr = str.toLowerCase();

    if (replacements[lowerStr]) {
      return replacements[lowerStr];
    }

    return str
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const searchFunction = (e) => {
    e.preventDefault();
    setPage(0);
    setPageCount(1);
    get_user_list();
  };

  useEffect(() => {
    get_user_list();
  }, [page, rowsPerPage]);

  const handleDeleteMember = async (memberId) => {
    console.log(memberId, "memberIdmemberIdmemberId");
    setDeleteLoading(true);
    const response = await delete_Case_api(memberId);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setDeleteDialogOpen(false);
      get_user_list();
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setDeleteDialogOpen(false);
    }
    setDeleteLoading(false);
  };

  const handleDelete = (row) => {
    console.log(row, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };

  const handleClickEdit = (row) => {
    navigate(`/list-cases/update/${row._id}`);
  };
  const handleClickDetail = (row) => {
    navigate(`/list-cases/detail/${row._id}`);
  };

  const applyFilters = () => {
    setTempFilters({
      caseType: caseType,
      occurrencePeriod: selectedOccurancePeriod,
      state: states,
      status: caseStatus,
      startDate: startDate,
      endDate: endDate,
    });
    setPage(0);
    setPageCount(1);
    handleCloseDrawer();
    // get_user_list();
  };

  const clearFilters = () => {
    setCaseType("");
    setselectedOccurancePeriodId("");
    setStartDate(null);
    setEndDate(null);
    setStates("");
    setCaseStatus("");
    setSearchText("");
    setTempFilters((prev) => ({ ...prev, state: null }));
    setTempFilters((prev) => ({ ...prev, occurrencePeriod: null }));
    setTempFilters((prev) => ({ ...prev, caseType: null }));
    setTempFilters((prev) => ({ ...prev, caseoccurrencePeriodType: null }));
    setTempFilters((prev) => ({ ...prev, startDate: null }));
    setTempFilters((prev) => ({ ...prev, endDate: null }));
    setPage(0);
    setPageCount(1);
    get_user_list("", "", "", "", "", "");
    handleCloseDrawer();
  };
  console.log(
    tempFilters,
    "tempFilterstempFiltetempFilterstempFiltersrstempFilters"
  );

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "mdi:pencil-outline",
      handleClick: handleClickEdit,
    },
    {
      label: "Delete",
      icon: "mdi:delete-outline",
      handleClick: (row, index) => handleDelete(row),
    },
    {
      label: "Detail Case",
      icon: "bxs:detail",
      handleClick: (row, index) => handleClickDetail(row),
    },
    {
      label: "Change Case Status",
      icon: "fluent:status-12-filled",
      handleClick: (row, index) => handleChangeCaseStatusOpen(row),
    },
    {
      label: "Change Attorney",
      icon: "simple-icons:homeadvisor",
      handleClick: (row, index) => handleopenChangeAdvisor(row),
    },
  ];
  const statusToKeyMap = {
    pending: "open_Cases_count",
    recovered: "closed_Cases_count",
    assigned: "assined_cases_count",
    failed: "failed_cases_count",
    all: "all_Cases_count",
  };

  const success_ratio =
    dashboardData?.closed_Cases_count > 0
      ? (dashboardData?.closed_Cases_count / dashboardData?.all_Cases_count) *
        100
      : 0;

  console.log(dashboardData, "dashboardDatadashboardDatadashboardData");
  const cardItems = [
    {
      title: "Success Ratio",
      key: "success_ratio",
      icon: <TrendingUpIcon sx={{ color: "#fff", fontSize: 22 }} />, // You can use any relevant icon
      gradient: "linear-gradient(135deg, #388E3C, #66BB6A)", // Greenish gradient
      value: `${success_ratio.toFixed(2)}%`,
    },
    // {
    //   title: "Pending Cases",
    //   key: "open_Cases_count",
    //   icon: <FolderOpenIcon sx={{ color: "#fff", fontSize: 22 }} />,
    //   gradient: "linear-gradient(135deg, #F57C00, #FFA726)",
    // },
    {
      title: "Recovered Cases",
      key: "closed_Cases_count",
      icon: <DoneAllIcon sx={{ color: "#fff", fontSize: 22 }} />,
      gradient: "linear-gradient(135deg, #0288D1, #26C6DA)",
    },
    {
      title: "Assigned  Cases",
      key: "assined_cases_count",
      icon: <AssignmentTurnedInIcon sx={{ color: "#fff", fontSize: 22 }} />,
      gradient: "linear-gradient(135deg, #6e4b45, #6e4b45)",
    },
    {
      title: "Failed Cases",
      key: "failed_cases_count",
      icon: <SmsFailedIcon sx={{ color: "#fff", fontSize: 22 }} />,
      gradient: "linear-gradient(135deg, #D32F2F, #d7635b)", // Bright red
    },
    {
      title: "All Cases",
      key: "all_Cases_count",
      icon: <AllInboxIcon sx={{ color: "#fff", fontSize: 22 }} />,
      gradient: "linear-gradient(135deg, #455A64, #78909C)", // Slate blue
    },
  ];
  const caseTypeToKeysMap = {
    unwanted_spam: ["open_cases_count", "failed_cases_count"],
    scam_recovery: ["closed_Cases_count", "completed_cases_count"],
    both: [
      "open_Cases_count",
      "closed_Cases_count",
      "completed_cases_count",
      "failed_cases_count",
      "all_Cases_count",
    ],
  };

  const getFilteredCardItems = () => {
    // If no filters applied, return all
    if (
      !tempFilters.status &&
      !tempFilters.caseType &&
      !tempFilters.occurrencePeriod &&
      !tempFilters.state
    ) {
      return cardItems;
    }

    let filteredKeys = [];

    // Apply status filter
    if (
      tempFilters.status &&
      statusToKeyMap[tempFilters.status.toLowerCase()]
    ) {
      filteredKeys.push(statusToKeyMap[tempFilters.status.toLowerCase()]);
    }

    // Add more logic if caseType, state, occurrencePeriod map to different keys
    // For now we're filtering just based on status, extend this if cardItems support other filters

    return cardItems.filter((item) =>
      filteredKeys.length > 0 ? filteredKeys.includes(item.key) : true
    );
  };

  const filteredCardItems = getFilteredCardItems();

  const cardStyle = {
    flex: "1 1 calc(25% - 24px)", // 4 cards per row with spacing
    minWidth: "220px", // ensure a consistent smaller size
    maxWidth: "240px",
    padding: 2,
    borderRadius: 2,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 2,
    height: 100, // reduced height
  };

  useEffect(() => {
    get_user_list();
  }, []);

  const iconContainerStyle = {
    backgroundColor: "rgba(255,255,255,0.2)",
    borderRadius: "50%",
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  useEffect(() => {
    get_user_list(
      tempFilters.caseType || "",
      // tempFilters.occurrencePeriod || "",
      tempFilters.status || "",
      tempFilters.state || "",
      tempFilters.startDate || "",
      tempFilters.endDate || ""
    );
  }, [tempFilters]);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="d-flex justify-content-between flex-wrap align-items-center mb-4 members_heading">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <IconButton onClick={() => navigate(-1)} style={{ color: "#000" }}>
              <ArrowBackIcon />
            </IconButton>

            <h3>
              Attorney Cases Details <br />{" "}
              <span style={{ fontSize: "20px" }}>({stateData?.name})</span>
            </h3>
          </div>
          <div className="text-end">
            <Button
              variant="contained"
              className="me-1"
              onClick={handleExportCsv}
            >
              <DownloadIcon sx={{ mr: 1 }} />
              Export CSV
            </Button>
            <Button
              variant="contained"
              startIcon={<FilterListIcon />}
              onClick={handleopenFilterDrawer}
            >
              Filters
            </Button>
          </div>
        </div>
        <Grid container spacing={2} mb={2}>
          {filteredCardItems.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
              <Card
                className="mui-card-attorney"
                sx={{
                  ...cardStyle,
                  background: item.gradient,
                  color: "#fff",
                  display: "flex",
                  padding: 2,
                  borderRadius: 2,
                  height: 100,
                  gap: 2,
                }}
              >
                <Box sx={iconContainerStyle}>{item?.icon}</Box>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "rgba(255,255,255,0.85)" }}
                  >
                    {item?.title}
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {item?.value ?? dashboardData?.[item?.key] ?? 0}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>

        {(tempFilters.caseType ||
          tempFilters.occurrencePeriod ||
          tempFilters.startDate ||
          tempFilters.endDate ||
          tempFilters.state ||
          tempFilters.status) && (
          <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
            {tempFilters.caseType && (
              <div className="filter-chip">
                Case Type: {show_proper_words(tempFilters.caseType)}
                <span
                  className="chip-close"
                  onClick={() => {
                    setCaseType(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      caseType: null,
                    }));
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {/* {tempFilters.occurrencePeriod && (
              <div className="filter-chip">
                Occurrence Period:{" "}
                {show_proper_words(tempFilters.occurrencePeriod)}
                <span
                  className="chip-close"
                  onClick={() => {
                    setselectedOccurancePeriodId(null);
                    setStartDate(null);
                    setEndDate(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      occurrencePeriod: null,
                      startDate: null,
                      endDate: null,
                    }));
                  }}
                >
                  ×
                </span>
              </div>
            )} */}

            {tempFilters.status && (
              <div className="filter-chip">
                Status: {show_proper_words(tempFilters.status)}
                <span
                  className="chip-close"
                  onClick={() => {
                    setCaseStatus(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      status: null,
                    }));
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {tempFilters.startDate && (
              <div className="filter-chip">
                Start Date: {moment(tempFilters.startDate).format("YYYY-MM-DD")}
                <span
                  className="chip-close"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setselectedOccurancePeriodId(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      startDate: null,
                      endDate: null,
                      occurrencePeriod: null,
                    }));
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {tempFilters.endDate && (
              <div className="filter-chip">
                End Date: {moment(tempFilters.endDate).format("YYYY-MM-DD")}
                <span
                  className="chip-close"
                  onClick={() => {
                    setEndDate(null);
                    setStartDate(null);
                    setselectedOccurancePeriodId(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      endDate: null,
                      startDate: null,
                      occurrencePeriod: null,
                    }));
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {tempFilters.state && (
              <div className="filter-chip">
                State: {tempFilters.state}
                <span
                  className="chip-close"
                  onClick={() => {
                    setStates(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      state: null,
                    }));
                  }}
                >
                  ×
                </span>
              </div>
            )}

            <button
              className="btn btn-sm filter-chip-clear-all"
              onClick={() => {
                setCaseType(null);
                setselectedOccurancePeriodId(null);
                setCaseStatus(null);
                setStartDate(null);
                setEndDate(null);
                setStates(null);
                setTempFilters({
                  caseType: null,
                  occurrencePeriod: null,
                  startDate: null,
                  endDate: null,
                  state: null,
                  status: null,
                });
              }}
            >
              Clear All <span className="chip-close clear-all">✕</span>
            </button>
          </div>
        )}

        <div className="p-0">
          <CustomMUITable
            TABLE_HEAD={TABLE_HEAD}
            data={userList}
            pagePagination={true}
            MENU_OPTIONS={MENU_OPTIONS}
            custom_pagination={{
              total_count: totalCount,
              rows_per_page: rowsPerPage,
              page: page,
              handleChangePage: handleChangePage,
              onRowsPerPageChange: handleChangeRowsPerPage,
            }}
            custom_search={{
              searchText: searchText,
              setSearchText: setSearchText,
              handleSubmit: searchFunction,
            }}
            pageCount={pageCount}
            totalPages={totalPages}
            handleChangePages={handleChangePages}
          />
        </div>
      </div>

      <CustomDrawer
        isOpenDrawer={recordingListState.drawerOpen}
        // onOpenDrawer={handleCloseDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle={`${
          recordingListState.selectedCategory ? "Filters" : "Filters"
        } `}
        componentToPassDown={
          <CasesFilterAttorney
            onCloseDrawer={handleCloseDrawer}
            selectedObject={recordingListState.selectedCategory}
            refreshList={get_user_list}
            memberList={membersList}
            setSourceFilter={setSourceFilter}
            setSourceList={setSourceList}
            sourceList={sourceList}
            selectedSourceId={selectedSourceId}
            setSelectedSourceId={setSelectedSourceId}
            setOage={setPage}
            setPageCount={setPageCount}
            applyFilters={applyFilters}
            caseType={caseType}
            setCaseType={setCaseType}
            selectedOccurancePeriod={selectedOccurancePeriod}
            setselectedOccurancePeriodId={setselectedOccurancePeriodId}
            endDate={endDate}
            setEndDate={setEndDate}
            startDate={startDate}
            setStartDate={setStartDate}
            setStates={setStates}
            states={states}
            clearFilters={clearFilters}
            caseStatus={caseStatus}
            setCaseStatus={setCaseStatus}
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
            caseData={caseData}
            setCaseData={setCaseData}
            selectedAdvisor={selectedAdvisor}
            setSelectedAdvisor={setSelectedAdvisor}
          />
        }
      />
      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this Case?"}
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />
    </div>
  );
};

export default AttorneyCaseDetail;
